import Vue from 'vue'
import Router from 'vue-router'
import store from '@/config/store'
import {routerMode} from '@/config/fetch'
Vue.use(Router)
//路由配置
const routes = [{
    path: '/',
    name: 'login',
    component: resolve => require(['@/page/common/login.vue'], resolve)
},
{
    path: '/startExam',
    name: 'startExam',
    component: resolve => require(['@/page/studentSubject/startExam.vue'], resolve)
},
{
    path: '/examFinish',
    name: 'examFinish',
    component: resolve => require(['@/page/studentSubject/examFinish.vue'], resolve)
},
{
    path: '/home',
    name: 'home',
    component: resolve => require(['@/page/common/home.vue'], resolve),
    children: [
        {
            path: '/studentManage',
            name: 'studentManage',
            component: resolve => require(['@/page/studentManage/index.vue'], resolve)
        },
        {
            path: '/addStudent',
            name: 'addStudent',
            component: resolve => require(['@/page/studentManage/addStudent.vue'], resolve)
        },
        //考试管理
        {
            path: '/examManage',
            name: 'examManage',
            component: resolve => require(['@/page/examManage/index.vue'], resolve)
        },
        //科目管理
        {
            path: '/subjectManage',
            name: 'subjectManage',
            component: resolve => require(['@/page/subjectManage/index.vue'], resolve)
        },
        //题库管理
        {
            path: '/questionManage',
            name: 'questionManage',
            component: resolve => require(['@/page/questionManage/index.vue'], resolve)
        },
        {
            path: '/questionAdd',
            name: 'questionAdd',
            component: resolve => require(['@/page/questionManage/questionAdd.vue'], resolve)
        },
        {
            path: '/accountManage',
            name: 'accountManage',
            component: resolve => require(['@/page/accountManage/index.vue'], resolve)
        },
        {
            path: '/powerManage',
            name: 'powerManage',
            component: resolve => require(['@/page/accountManage/powerManage.vue'], resolve)
        },
        {
            path: '/studentInfo',
            name: 'studentInfo',
            component: resolve => require(['@/page/studentInfo/index.vue'], resolve)
        },
        {
            path: '/studentSubject',
            name: 'studentSubject',
            component: resolve => require(['@/page/studentSubject/index.vue'], resolve)
        },
        {
            path: '/workbench',
            component: function (resolve) {
                require(['@/page/workbench/index.vue'], resolve)
            }
        },
    ]
}
];
let router = new Router({
    //模式
    mode:routerMode,
    //页面滚动
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {
                x: 0,
                y: 0
            }
        }
    },
    routes
});
//页面加载时
router.beforeEach(function (to, from, next) {
    store.commit('setPageLoading', true);
    store.commit('setPath', to.path);
    if (/\/http/.test(to.path)) {
        let url = to.path.split('http')[1]
        window.location.href = `http${url}`
    } else {
        next();
    }
});
//页面销毁时
router.afterEach(function (to) {
    store.commit('setPageLoading', false);
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js